import { Route, Routes } from 'react-router-dom'
import Box from '@mui/material/Box'
import routes from '..'
import { getPageHeight } from './utils'
import HeaderProvider from 'hooks/headerContext'
import { Stack } from '@mui/system'
import Header from 'components/Header'
import AlertDialogProvider from 'hooks/AlertDialogContext'
import AlertDialog from 'components/atoms/alertdialog/AlertDialog'
import PrivateRoute from 'pages/auth/PrivateRoute'

function Pages() {
  return (
    // TODO: get `getPageTopSpacing` and add as margin top.
    <Box sx={{ height: (theme) => getPageHeight(theme) }}>
      <HeaderProvider>
        <AlertDialogProvider>
          <Stack>
            <Header />
            <AlertDialog />
            <Routes>
              {Object.values(routes).map(({ path, component: Component }) => {
                if (path === '/login' || path === '/third-party-login') {
                  return <Route key={path} path={path} element={<Component />} />
                } else {
                  return (
                    <Route
                      key={path}
                      path={path}
                      element={
                        <PrivateRoute>
                          <Component />
                        </PrivateRoute>
                      }
                    />
                  )
                }
              })}
            </Routes>
          </Stack>
        </AlertDialogProvider>
      </HeaderProvider>
    </Box>
  )
}

export default Pages
